import { useEffect, useState } from 'react';
const useFetchRecommendationPod = (cioClient, recommendationPods, fetchZeroStateOnFocus = false) => {
    const [recommendationsResults, setRecommendationsResults] = useState({});
    const [podsData, setPodsData] = useState({});
    const fetchRecommendationResults = async () => {
        if (!cioClient || !Array.isArray(recommendationPods) || recommendationPods.length === 0)
            return;
        const responses = await Promise.all(recommendationPods.map(({ podId, indexSectionName, ...parameters }) => cioClient.recommendations.getRecommendations(podId, {
            ...parameters,
            section: indexSectionName,
        })));
        const recommendationsPodResults = {};
        const recommendationsPodsData = {};
        responses.forEach(({ response, request }, index) => {
            const { pod, results } = response;
            if (pod?.id) {
                recommendationsPodResults[pod.id] = results?.map((item) => ({
                    ...item,
                    id: item?.data?.id,
                    section: recommendationPods[index]?.indexSectionName,
                    podId: pod.id,
                }));
                recommendationsPodsData[pod.id] = {
                    displayName: pod.display_name,
                    podId: pod.id,
                    request,
                };
            }
        });
        try {
            setRecommendationsResults(recommendationsPodResults);
            setPodsData(recommendationsPodsData);
        }
        catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
        }
    };
    useEffect(() => {
        if (fetchZeroStateOnFocus)
            return;
        fetchRecommendationResults();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cioClient, recommendationPods]);
    return { fetchRecommendationResults, recommendationsResults, podsData };
};
export default useFetchRecommendationPod;
